import React, { ReactNode } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import { RouteTabItem, RoutingTabs } from './RoutingTabs'

import { NonEmptyArrayReadOnly, Replace } from '../common/tsUtils'

export type RouteTabItemEnabled =
  Replace<RouteTabItem, {isDisabled?: false}>

export type RouteTabsSwitchProps = ({
  routeTabs: readonly [RouteTabItemEnabled, ...RouteTabItem[]]

  /**
   * Defaults to the first item of {@link routeTabs}
   * (which can't be disabled, otherwise {@link fallbackRoute} must be provided.
   */
  fallbackRoute?: undefined
} | {
  routeTabs: NonEmptyArrayReadOnly<RouteTabItem>

  /**
   * Must not be empty (because the first item of {@link routeTabs} can be disabled).
   */
  fallbackRoute: RouteTabItemEnabled
}) & {
  children?: ReactNode
}

export type RouteTabSwitchItems = RouteTabsSwitchProps['routeTabs']

export const RoutingTabsSwitch =
  ({routeTabs, fallbackRoute, children}: RouteTabsSwitchProps) =>
    <RoutingTabs routeTabs={routeTabs}>
      <Switch>
        {
          routeTabs.filter(_ => !_.isDisabled)
                   .map(({template, path, render}) =>
                     <Route key={template ?? path} path={template ?? path}>
                       {render()}
                     </Route>)
        }

        {children}

        {/* NOTE: Fallback route, must remain the last one */}
        <Route path="*">
          <Redirect to={fallbackRoute?.path ?? routeTabs[0].path}/>
        </Route>
      </Switch>
    </RoutingTabs>